var React = require('react');

function ShoppingBag (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2.5"},React.createElement("path",{"d":"M4.4 2L2 5.2v11.2A1.6 1.6 0 0 0 3.6 18h11.2a1.6 1.6 0 0 0 1.6-1.6V5.2L14 2H4.4zM2 5.2h14.4M12.4 8.4a3.2 3.2 0 1 1-6.4 0"})));
}

ShoppingBag.defaultProps = {"width":"18","height":"20","viewBox":"0 0 18 20"};

module.exports = ShoppingBag;

ShoppingBag.default = ShoppingBag;
